const unknownLabel = 'Chưa xác định';

const financialRepairStatusLabels = {
    BLOCKED: 'Chưa thể xử lý',
    REPAIRABLE: 'Có thể xử lý',
    CONSISTENT: 'Nhất quán',
    PROCESSING: 'Đang xử lý',
    COMPLETED: 'Đã hoàn tất',
    ALREADY_CORRECT: 'Đã chính xác',
};

const financialRepairIssueLabels = {
    DUPLICATE_OR_EXCESS_RECEIVABLE: 'Công nợ điều chỉnh ghi nhận thừa',
    MISSING_RECEIVABLE: 'Thiếu công nợ điều chỉnh',
    CUSTOMER_PROJECTION_MISMATCH: 'Số tổng trên hồ sơ chưa khớp',
    LEDGER_RECONCILIATION_REQUIRED: 'Cần đối soát nguồn tiền',
};

const financialRepairBlockerLabels = {
    REFUND_SOURCE_NOT_TRACEABLE: 'Không truy vết được nguồn hoàn tiền',
    REFUND_IN_PROGRESS: 'Có yêu cầu hoàn tiền đang xử lý',
    INVALID_RECEIPT_ITEM_MAPPING: 'Liên kết dịch vụ trên phiếu chưa hợp lệ',
    LOCKED_COMMISSION_PERIOD: 'Kỳ hoa hồng liên quan đã khóa',
};

const financialRepairActionLabels = {
    ADJUST_RECEIVABLE: 'Điều chỉnh công nợ',
    RECALCULATE_CUSTOMER_PROJECTION: 'Tính lại số tổng trên hồ sơ',
    RECONCILE_LEDGER: 'Đối soát nguồn tiền và phân bổ',
};

const financialRepairDirectionLabels = {
    DEBIT: 'Tăng công nợ',
    CREDIT: 'Giảm công nợ',
};

const receiptItemIssueReasonLabels = {
    CUSTOMER_SERVICE_NOT_FOUND: 'Không tìm thấy dịch vụ của khách hàng',
    SERVICE_NOT_BELONG_TO_CUSTOMER: 'Dịch vụ không thuộc khách hàng này',
    INVALID_ORIGIN_ID: 'Dịch vụ gốc không khớp',
    DELETED_SERVICE_HAS_ACTIVE_ALLOCATION: 'Dịch vụ đã hủy nhưng vẫn còn phân bổ tiền',
    INVALID_SERVICE_MAPPING: 'Liên kết dịch vụ không hợp lệ',
    INVALID_TRANSFERRED_LINEAGE: 'Thiếu lịch sử chuyển đổi dịch vụ',
};

const receiptItemTypeLabels = {
    SERVICE: 'Dịch vụ',
    PRODUCT: 'Sản phẩm',
    'Dịch vụ': 'Dịch vụ',
    'Sản phẩm': 'Sản phẩm',
};

export const financialRepairModeOptions = [
    { value: 'AUTO_REPAIR', label: 'Tự động sửa theo chứng từ' },
    { value: 'REBUILD', label: 'Tính lại số liệu và đối soát' },
];

const formatCode = (labels, value, emptyLabel = '—') => {
    if (value === null || value === undefined || value === '') return emptyLabel;
    return labels[value] || unknownLabel;
};

export const formatFinancialRepairStatus = value => formatCode(financialRepairStatusLabels, value);
export const formatFinancialRepairIssue = value => formatCode(financialRepairIssueLabels, value);
export const formatFinancialRepairBlocker = value => formatCode(financialRepairBlockerLabels, value);
export const formatFinancialRepairAction = value => formatCode(financialRepairActionLabels, value);
export const formatFinancialRepairDirection = value => formatCode(financialRepairDirectionLabels, value);
export const formatReceiptItemIssueReason = value => formatCode(receiptItemIssueReasonLabels, value);
export const formatReceiptItemType = value => formatCode(receiptItemTypeLabels, value);

export const getFinancialRepairStatusColor = status => ({
    BLOCKED: 'red',
    REPAIRABLE: 'orange',
    CONSISTENT: 'green',
    PROCESSING: 'blue',
    COMPLETED: 'green',
    ALREADY_CORRECT: 'green',
}[status]);

export const getFinancialRepairAlertType = status => ({
    BLOCKED: 'warning',
    CONSISTENT: 'success',
    COMPLETED: 'success',
    ALREADY_CORRECT: 'success',
}[status] || 'info');
